import {AxiosResponse, Method} from 'axios';
import requestHelper from './requestHelper';
import {APIInstance, HostUrlInstanceWithJson, HostUrlInstanceForUpload} from './interceptors';
import constants from '../constants';
import {BankVerificationRequest, BankVerificationResponse, BankVerificationOverrideRequest} from './types';

export default class API {
    public static async Call<T = object>(endpoint: string, method: Method = 'GET', data?: unknown): Promise<T | null> {
        return requestHelper(data, endpoint, APIInstance, method) as Promise<T | null>;
    }

    public static async CallFullResponse<T = object>(
        endpoint: string,
        method: Method = 'GET',
        data?: unknown,
        headers?: Record<string, string>,
    ): Promise<AxiosResponse<T> | null> {
        return requestHelper(
            data,
            endpoint,
            APIInstance,
            method,
            undefined,
            undefined,
            true,
            headers,
        ) as Promise<AxiosResponse<T> | null>;
    }

    public static async RequestToThisOrigin<T = object>(
        url: string,
        method: Method = 'GET',
        data?: unknown,
        headers?: Record<string, string>,
    ): Promise<T | null> {
        if (constants.IS_E2E_TEST) {
            return requestHelper(
                data,
                url.split('/')[1],
                APIInstance,
                method,
                undefined,
                undefined,
                undefined,
                headers,
            ) as Promise<T | null>;
        }

        return requestHelper(
            data,
            url,
            HostUrlInstanceWithJson,
            method,
            undefined,
            undefined,
            undefined,
            headers,
        ) as Promise<T | null>;
    }

    public static async Upload<T = object>(
        url: string,
        method: Method,
        data: object,
        uploadProgress?: (p: number) => void,
    ): Promise<T | null> {
        return requestHelper(data, url, HostUrlInstanceForUpload, method, uploadProgress) as Promise<T | null>;
    }

    public static LogToMixPanel(event: string, args: Record<string, unknown>) {
        const props: Record<string, unknown> = {};

        const {navigator, screen} = window;

        const navigatorKeys: (keyof Navigator)[] = [
            'appName',
            'product',
            'appVersion',
            'userAgent',
            'language',
            'onLine',
            'platform',
            'cookieEnabled',
        ];
        const screenKeys: (keyof Screen)[] = [
            'width',
            'height',
            'availWidth',
            'availHeight',
            'colorDepth',
            'pixelDepth',
        ];

        navigatorKeys.forEach((p) => {
            props[p] = navigator[p];
        });
        screenKeys.forEach((p) => {
            props[p] = screen[p];
        });

        for (const k in args) {
            props[k] = args[k];
        }

        return API.Call(`log/agent/${event}`, 'POST', props);
    }

    public static async VerifyBankAccount(data: BankVerificationRequest): Promise<BankVerificationResponse | null> {
        return API.Call<BankVerificationResponse>('/v2/bank-verification/verify', 'POST', data);
    }

    public static async OverrideBankVerification(
        data: BankVerificationOverrideRequest,
    ): Promise<{success: boolean; overriddenBy: string; timestamp: string} | null> {
        return API.Call<{success: boolean; overriddenBy: string; timestamp: string}>(
            '/v2/bank-verification/override',
            'POST',
            data,
        );
    }
}
